/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { useEditorMainContext } from "../contexts/EditorMainContext";
import { useCallback } from "react";

export function useCommand(commandId: string): [(...args: unknown[]) => Promise<unknown>] {
	const editorMainCtx = useEditorMainContext();

	const executeCommand = useCallback(
		(...args: unknown[]) => {
			return editorMainCtx.commandsService.execute(commandId, ...args);
		},
		[ commandId ]
	);

	return [ executeCommand ];
}
